import { render, staticRenderFns } from "./dangaotai.vue?vue&type=template&id=a922ef14&"
import script from "./dangaotai.vue?vue&type=script&lang=js&"
export * from "./dangaotai.vue?vue&type=script&lang=js&"
import style0 from "./dangaotai.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports